module.exports = "\n<div class=\"bubble-float\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BubbleFloat/BubbleFloat.vue
// module id = 97
// module chunks = 0